import {CoreSettingsParameters, Settings} from '@gongxigames/framework/core';
import {SlotSettingsParameters} from '@gongxigames/framework/slot/configs/SlotSettings';
import {AsyncActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/AsyncActDecorator';

export class LoadMetaDataForResourcesAct extends AsyncActDecorator {
    public async execute(): Promise<void> {
        this.addLoadingResourcesForModules();
        await this.resourceManager.loadMetaDataForResources();
    }

    private addLoadingResourcesForModules(): void {
        const settings = this.settings as Settings<SlotSettingsParameters & CoreSettingsParameters>
        const resourceManager = this.resourceManager;
        const modules = this.installer.getEnabledModules(settings.get('platform'));

        for (const module of modules) {
            const resourcesToLoad = module.getResourcesToLoad?.();

            if (resourcesToLoad) {
                resourceManager.addResourcesPackToLoad(resourcesToLoad);
            }
        }
    }

    getName(): string {
        return 'LoadMetaDataForResourcesAct';
    }
}